module.exports = __webpack_public_path__ + "static/media/portfolio.50873d0a.png";